
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 15","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":"1.488","width":"13","height":"13","rx":"3","stroke":"#545C69"}}),_c('path',{attrs:{"d":"M3.782 8.453l2.652 2.32 3.937-5.357","stroke":"#545C69","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    